import {fromEvent, Observable} from 'rxjs';

import {FrontWindow} from '../browser/browserHelpers';

/** Creates an Observable that emits events every time the online event is fired on the given window.
 * @param {Window} window (unused on mobile)
 * @returns {Observable<unknown>} An observable emitting when window.navigator.onLine becomes false.
 */
export function fromOfflineEvent(window: FrontWindow): Observable<unknown> {
  return fromEvent(window, 'offline');
}

/** Creates an Observable that emits events every time the online event is fired on the given window.
 * @param {Window} window (unused on mobile)
 * @returns {Observable<unknown>} An observable emitting when window.navigator.onLine becomes true.
 */
export function fromOnlineEvent(window: FrontWindow): Observable<unknown> {
  return fromEvent(window, 'online');
}
